import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { AccountBalance } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const ButtonPixNode = memo(({ id, data, isConnectable, selected }) => {
  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<AccountBalance />}
      title="Chave PIX"
      color="#683AC8"
      bgColor="#FAFBFF"
      isConnectable={isConnectable}
      selected={selected}
    >
      {/* Message preview */}
      {data?.message && (
        <div
          style={{
            fontSize: 11,
            color: "#444",
            lineHeight: 1.4,
            marginBottom: 6,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            maxWidth: 200,
          }}
        >
          {data.message}
        </div>
      )}

      {/* PIX button label */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "5px 10px",
          borderRadius: 6,
          fontSize: 11,
          fontWeight: 600,
          backgroundColor: "#EDE7F6",
          color: "#683AC8",
          border: "1px solid #D1C4E9",
        }}
      >
        <span
          style={{
            width: 18, height: 18, borderRadius: 4,
            backgroundColor: "#683AC8", color: "#fff",
            display: "inline-flex", alignItems: "center",
            justifyContent: "center", fontSize: 10,
            fontWeight: 800, flexShrink: 0,
          }}
        >
          1
        </span>
        Copiar chave PIX
      </div>

      {/* PIX key preview */}
      {data?.pixKey && (
        <div style={{ fontSize: 9, color: "#999", marginTop: 4 }}>
          Chave: {data.pixKey}
        </div>
      )}
    </NodeWrapper>
  );
});

ButtonPixNode.displayName = "ButtonPixNode";
export default ButtonPixNode;
